import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  currentSku: string;
  predecessorSku: string;
  onSave: () => void;
}

interface State {
}

export default class SKUAssignmentModal extends React.PureComponent<Props, State> {
  render(): React.ReactNode {
    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={() => this.props.toggle()}
        centered={true}
        className="sku-assignment-modal"
      >
        <ModalBody>
          <h2>SKU Assignment</h2>
          <p>
            Do you want to assign <strong>SKU - {this.props.currentSku}</strong> to{' '}
            <strong>Pred SKU - {this.props.predecessorSku}</strong>?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color={'secondary'}
            className='btn btn-secondary'
            onClick={() => this.props.toggle()}
          >
            Cancel
          </Button>

          <Button
            color={'primary'}
            className='btn btn-primary'
            onClick={() => this.props.onSave()}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
